import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { DataAccessAuthorizationApiService } from "./data-access-authorization-api.service";

@NgModule({
    imports: [CommonModule],
    providers: [DataAccessAuthorizationApiService],
})
export class SharedDataAccessAuthorizationApiModule {}
